import { Text } from "@mantine/core";

import { StyledCheckbox } from "../../../../components/shared/_FormInputs/CheckboxGroup/CheckboxGroup.styled";
interface Props {
  checked: any;
  index: number;
  onChange: (e: any) => void;
  disabled?: boolean;
}
const NaCheckbox = ({ index, ...props }: Props) => {
  return (
    <StyledCheckbox
      size="md"
      key={`check-n/a-${index}`}
      label={<Text style={{ whiteSpace: "nowrap" }}>N/A</Text>}
      labelPosition="left"
      name={String(index)}
      style={{ flex: 1 }}
      {...props}
    />
  );
};
export default NaCheckbox;
